// extracted by mini-css-extract-plugin
export var coffeesContainer = "styles-module--coffeesContainer--3LOb1";
export var coffeeCard = "styles-module--coffeeCard--3NnUX";
export var coffeeRegionTagline = "styles-module--coffeeRegionTagline--_x6l3";
export var coffeeRegionTitle = "styles-module--coffeeRegionTitle--22g_s";
export var coffeeInfoContainer = "styles-module--coffeeInfoContainer--3f2_5";
export var infoRowItem = "styles-module--infoRowItem--2ff49";
export var coffeeProducedBy = "styles-module--coffeeProducedBy--39cD0";
export var coffeeProducedByValue = "styles-module--coffeeProducedByValue--3p8K1";
export var moreInfoAnchor = "styles-module--moreInfoAnchor--zntfp";